
import { Content, Header, Nav, Sidebar } from "@/components/Layouts";
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "Layout3",
  components: {
    Header,
    Content,
    Sidebar,
    Nav,
  },
})
export default class extends Vue {}
